module.exports = __webpack_public_path__ + "src/assets/img/cmdCloseTrunk.b00e339f.svg";